/* 支付页内可用券列表 */

<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>{{ payResult ? '支付成功' : '支付失败'}}</span>
      <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="close"></i>
    </header>
    <main v-if="payResult && img_class_name=='alipay'">
      <p :class="$style.red">恭喜您成功领取福利礼包！</p>
      <p :class="$style.red">您的礼包码为：{{ giftCode }}</p>
      <p>您可点击下方“复制礼包码”，前往游戏中心</p>
      <p>的礼包兑换入口，输入后即可成功领取</p>
      <p>如有任何疑问，请<span @click="contact" :class="$style.red">联系客服</span></p>
      <button class="copy-btn" :data-clipboard-text="giftCode">复制礼包码</button>
      <p :class="$style.hint">可前往“福利 - 礼包”查看奖励 <span @click="openFloat" v-if="openFloatVisible">点击前往 >></span></p>
    </main>
    <main v-else-if="!payResult && img_class_name=='alipay'">
      <p style="margin-top: 0px;margin-bottom: 30px;font-weight: 700;">请以游戏内实际到账为准</p>
      <p style="margin-bottom: 30px;color:#D80000;font-weight: 700;font-size: 16px;">使用支付宝支付，可获得双重好礼</p>
      <p style="margin-bottom: 20px;color:#7E7E7E;font-size: 12px;" v-if="!payResult">若已支付成功，可点击下方刷新按钮</p>
      <p style="margin-bottom: 20px;color:#7E7E7E;font-size: 12px;" v-else></p>
      <div :class="$style.btnGroup">
        <button @click="refresh" v-if="!payResult">刷新</button>
        <button @click="close">我已知晓</button>
      </div>
    </main>
    <main v-else>
      <p style="margin-top: 0px;margin-bottom: 25px;font-weight: 700;">请以游戏内实际到账为准</p>
      <p style="font-size: 16px;font-weight: 700;margin-bottom: 5px;">支付宝超值活动，<span style="color:#D80000;font-weight: 700;">通过支付宝</span>渠道</p>
      <p style="font-size: 16px;font-weight: 700;margin-bottom: 5px;">任意<span style="color:#D80000;font-weight: 700;">支付</span>一笔，可获得额外豪礼，</p>
      <p style="margin-bottom: 20px;font-size: 16px;font-weight: 700;">双重奖励等您拿</p>
      <p style="margin-bottom: 14px;color:#7E7E7E;font-size: 12px;" v-if="!payResult">若已支付成功，可点击下方刷新按钮</p>
      <p style="margin-bottom: 20px;color:#7E7E7E;font-size: 12px;" v-else></p>
      <div :class="$style.btnGroup">
        <button @click="refresh" v-if="!payResult">刷新</button>
        <button @click="close">我已知晓</button>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import isFullScreen from '@/libs/business/fullScreen'
import Clipboard from 'clipboard';
import { versionCompare, isPure } from '@/libs/utils'
import { buryReportV2 } from '@/libs/business/account';

export default {
  name: '',
  props: {
  },
  data() {
    return {
      fullScreen: '',
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`,
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    this.copyInit();
  },
  computed: {
    ...mapActions({
      openCustomer: 'global/openCustomer'
    }),
    ...mapState({
      giftCode: state => state.pay.transferGiftCode,
      payResult: state => state.pay.payResult,
      img_class_name: state => state.pay.img_class_name,
      order_info: state => state.pay.order_info,
      order_sn: state => state.pay.order_sn,
    }),
    openFloatVisible() {
      const device_info = this.$getStorage('device_info');
      if (versionCompare(device_info.sdkVersion, '4.5.3') || !isPure()) {
        return true
      }
      return false
    },
  },
  methods: {
    contact() {
      this.openCustomer()
    },
    close() {
      this.$store.dispatch('pay/giftHintClose')
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
        this.copy.destroy(); // 销毁，否则其他按钮会受影响
      });
    },
    openFloat() {
      this.$store.dispatch('pay/giftHintClose', true)
    },
    refresh() {
      buryReportV2(this.img_class_name=='alipay' ? 'LEAD_APP_ALI_REFRESH' : 'LEAD_APP_WX_REFRESH', {
        order_sn: this.order_sn,
        money: this.order_info.zfAmount / 100
      })
      this.$store.dispatch('pay/queryOrderResult');
    }
  }
};
</script>

<style lang="scss" module>
@import "../../assets/css/common.scss";
.wrap {
  @include common-window();
  height: 5.2rem;
  overflow: hidden;
  > header {
    position: relative;
    padding: 0.28rem 0 0 0.33rem;
    > span {
      font-weight: 600;
      font-style: normal;
    }
    .fanhui {
      position: absolute;
      top: .34rem;
      right: .2rem;
      width: .34rem;
      height: .24rem;
      color: #FFFFFF;
    }
  }
  > main {
    border-radius: 0;
    position: relative;
    text-align: center;
    padding-top: .5rem;
    .red {
      color: #DC2626;
      font-weight: 700;
      font-size: .32rem;
      margin-bottom: .24rem;
    }
    > p {
      color: #000000;
      font-weight: 500;
      font-size: .24rem;
      line-height: .3rem;
    }
    button {
      @include common-button();
      width: 3.6rem;
      height: .66rem;
      font-size: .32rem;
      margin: .32rem auto .24rem auto;
      &:active {
        opacity: 0.8;
      }
    }
    .btnGroup {
      display: flex;
      align-items: center;
      justify-content: center;
      > button {
        width: 2.2rem;
        height: .66rem;
        font-size: .3rem;
        margin: 0 .2rem;
      }
    }
    .hint {
      color: #7E7E7E;
      font-size: .24rem;
      > span {
        color: #FF0000;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    height: 260px;
    > header {
      position: relative;
      padding: 14px 0 0 16px;
      > span {
        font-weight: 600;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      border-radius: 0;
      position: relative;
      text-align: center;
      padding-top: 25px;
      .red {
        color: #DC2626;
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 12px;
      }
      > p {
        color: #000000;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
      }
      button {
        @include common-button();
        width: 180px;
        height: 33px;
        font-size: 16px;
        margin: 16px auto 12px auto;
        &:active {
          opacity: 0.8;
        }
      }
      .btnGroup {
        display: flex;
        align-items: center;
        justify-content: center;
        > button {
          width: 110px;
          height: 33px;
          font-size: 15px;
          margin: 0 10px;
        }
      }
      .hint {
        color: #7E7E7E;
        font-size: 12px;
        > span {
          color: #FF0000;
        }
      }
    }
  }
}
</style>